module.exports = __webpack_public_path__ + "static/media/book.b2ac662f.svg";